import { toast } from 'react-toastify';
/** @helper xml-request-helper */
/**
 * @param config - expect { onSuccess, onError, body, method, token, url }
 * onSuccess: function;
 * onError: function;
 * body: Object/Array
 * method: string
 * token: string
 * url: string
 * successMessage: string
 * errorMessage: string
 */

export const httpRequest = (config) => {
    const request = new XMLHttpRequest();
    request.onreadystatechange = () => {
        if (request.readyState === XMLHttpRequest.DONE) {
            if (request.status === 0 || (request.status >= 200 && request.status < 400)) {
                const successMessage = config.successMessage || 'Request completed successfully';
                toast(successMessage, { type: toast.TYPE.SUCCESS });
                if (typeof config.onSuccess === 'function') {
                    config.onSuccess(request.responseText);
                }
            } else {
                const errorMessage = config.errorMessage || 'Some error happened. Please try again later.';
                toast(errorMessage, { type: toast.TYPE.ERROR });
                if (typeof config.onError === 'function') {
                    config.onError(request.responseText);
                }
            }
        }
    };
    request.open(config.method, config.url, true);
    if (config.token) {
        request.setRequestHeader('RequestVerificationToken', config.token);
    }
    request.send(config.body || null);
};
